var map = {
	"./blue_heart.png": "2145",
	"./purple_heart.png": "f21b",
	"./red_heart.png": "46cf",
	"./s_cyan_heart.png": "a691",
	"./s_pink_heart.png": "eb84",
	"./s_yellow_heart.png": "e3dd",
	"./sky_blue_heart.png": "df6d",
	"./yellow_heart.png": "541c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9d79";